export const version = "1.7.17-daily-20260827-0";
export const channel = "daily";
export const gitcommit = "17d42599f";
